/** @deprecated use tokens */
export var shadeMap = {
    lightest: 50,
    lighter: 300,
    light: 400,
    base: 500,
    dark: 600,
    darker: 700,
    darkest: 1000,
};
var getColorFromTokens = function (color, tokens) {
    // using light for these since mui doesnt handle inverse palettes.
    return {
        25: tokens["color_global_functional_light_".concat(color, "_25")],
        50: tokens["color_global_functional_light_".concat(color, "_50")],
        100: tokens["color_global_functional_light_".concat(color, "_100")],
        200: tokens["color_global_functional_light_".concat(color, "_200")],
        300: tokens["color_global_functional_light_".concat(color, "_300")],
        400: tokens["color_global_functional_light_".concat(color, "_400")],
        500: tokens["color_global_functional_light_".concat(color, "_500")],
        600: tokens["color_global_functional_light_".concat(color, "_600")],
        700: tokens["color_global_functional_light_".concat(color, "_700")],
        800: tokens["color_global_functional_light_".concat(color, "_800")],
        900: tokens["color_global_functional_light_".concat(color, "_900")],
        1000: tokens["color_global_functional_light_".concat(color, "_1000")],
    };
};
export var getColorsFromTokens = function (tokens) {
    return {
        purple: getColorFromTokens('purple', tokens),
        blue: getColorFromTokens('blue', tokens),
        green: getColorFromTokens('green', tokens),
        yellow: getColorFromTokens('yellow', tokens),
        red: getColorFromTokens('red', tokens),
        neutral: getColorFromTokens('neutral', tokens),
        magenta: getColorFromTokens('magenta', tokens),
    };
};
export var getBrandColor = function (colors, mainBrandColor) {
    return (Object.values(colors).find(function (colorMap) {
        return Object.values(colorMap).includes(mainBrandColor);
    }) || colors.purple);
};
export var getBrandShadeAliasMap = function (color, mainColor) {
    var valueList = Object.values(color);
    var mainIndex = valueList.indexOf(mainColor);
    var light = valueList[Math.max(mainIndex - 2, 0)];
    var main = valueList[mainIndex];
    var dark = valueList[Math.min(mainIndex + 2, valueList.length - 1)];
    return {
        light: light,
        main: main,
        dark: dark,
        A200: valueList[Math.max(mainIndex - 1, 0)],
        A400: main,
        A700: dark,
    };
};
